import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import api, { img, money } from "../lib/api";

export default function OrderConfirmation() {
  const [sp] = useSearchParams();
  const num = sp.get("order");
  const [order, setOrder] = useState(null);
  useEffect(() => { if (num) api.get(`/orders/track/${num}`).then(r => setOrder(r.data)).catch(() => {}); }, [num]);

  return (
    <div className="max-w-3xl mx-auto px-5 lg:px-10 py-20 text-center">
      <CheckCircle2 size={56} strokeWidth={1} className="mx-auto text-moss mb-6" />
      <h1 className="serif text-5xl mb-3">Your Order is Confirmed.</h1>
      <p className="text-forest/60 mb-2">Thank you. A confirmation has been sent to your email.</p>
      {num && <p className="eyebrow text-forest/70 mb-10" data-testid="confirmation-order-number">Order {num}</p>}

      {order && (
        <div className="bg-beige/40 p-8 text-left mb-8">
          <div className="divide-y divide-sage/20 mb-6">
            {order.items.map((it) => (
              <div key={it.slug} className="flex gap-4 py-4">
                <img src={img(it.image)} alt="" className="h-16 w-14 object-cover bg-ivory" />
                <div className="flex-1"><div className="serif text-lg">{it.name}</div><div className="text-xs text-forest/50">Qty {it.quantity} · {it.size}</div></div>
                <span className="text-sm">{money(it.price * it.quantity)}</span>
              </div>
            ))}
          </div>
          <div className="flex justify-between border-t border-sage/30 pt-4"><span className="serif text-xl">Total</span><span className="serif text-2xl">{money(order.total)}</span></div>
          <div className="mt-6 text-sm text-forest/65">
            <p className="mb-1"><strong className="text-forest">Payment:</strong> {order.payment.status === "paid" ? "Paid" : order.payment.status}</p>
            <p><strong className="text-forest">Shipping to:</strong> {order.shipping_address.address}, {order.shipping_address.city}, {order.shipping_address.state} {order.shipping_address.pincode}</p>
          </div>
        </div>
      )}

      <p className="serif text-xl text-forest/70 mb-8">Every order supports a more thoughtful approach to beauty.</p>
      <div className="flex flex-wrap gap-4 justify-center">
        {num && <Link to={`/track?order=${num}`} className="btn-primary" data-testid="confirmation-track">Track Order</Link>}
        <Link to="/shop" className="btn-outline" data-testid="confirmation-continue">Continue Shopping</Link>
      </div>
    </div>
  );
}
